import { Lab, Slide, SlideAdmin } from "pwapi";

import DateRange from "components/customInputs/DateRangeInput";
import SelectInput from "components/customInputs/SelectInput";
import TextInput from "components/customInputs/TextInput";

import {
  FilterLabels,
  FilterOptions,
  SlideFiltersState,
} from "../casesTable/CaseAdminFilters.contracts";

type SlidesFiltersProps = SlideFiltersState & {
  labs: Lab[];
  onChange: Function;
  onChangeDateRange: Function;
};

const dateInputLabel = {
  slidesScannedDate: "Date Received",
  slidesExpectedUploadBy: "Date Collected",
};

const mapDateInputsToLabel = Object.entries(dateInputLabel).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [`${key}Before`]: `${value} - Before`,
    [`${key}After`]: `${value} - After`,
  }),
  {} as Pick<
    FilterLabels<SlideFiltersState>,
    | "slidesScannedDateAfter"
    | "slidesScannedDateBefore"
    | "slidesExpectedUploadByAfter"
    | "slidesExpectedUploadByBefore"
  >
);
export const mapSlidesFilterToLabel: FilterLabels<SlideFiltersState> = {
  slidesStatus: "Slide Status",
  slidesStainName: "Stain",
  slidesLab: "Scanning Lab",
  slidesSlideReviewReason: "Review Reason",
  slidesQcStatus: "QC Status",
  ...mapDateInputsToLabel,
};

export const createMapSlidesFilterToOptions: (
  labs: Lab[]
) => FilterOptions<SlideFiltersState> = (labs) => ({
  slidesStatus: Object.values(Slide.status).map((v) => ({
    label: v,
    value: v,
  })),
  slidesLab: labs?.map((v) => ({ label: v.name, value: `${v.id}` })),
  slidesSlideReviewReason: Object.values(SlideAdmin.slide_review_reason).map(
    (v) => ({
      label: v,
      value: v,
    })
  ),
  slidesQcStatus: Object.values(SlideAdmin.qc_status).map((v) => ({
    label: v,
    value: v,
  })),
});

const SlidesFilters = (props: SlidesFiltersProps) => {
  const mapSlidesFilterToOptions = createMapSlidesFilterToOptions(props.labs);
  return (
    <>
      <SelectInput
        id="slidesStatus"
        label={mapSlidesFilterToLabel["slidesStatus"]}
        defaultLabel="All Statuses"
        options={mapSlidesFilterToOptions["slidesStatus"]}
        value={props.slidesStatus}
        onChange={(e: any) =>
          props.onChange("slidesStatus", e.target.value || "")
        }
      />
      <SelectInput
        id="slidesQcStatus"
        label={mapSlidesFilterToLabel["slidesQcStatus"]}
        defaultLabel="All Statuses"
        options={mapSlidesFilterToOptions["slidesQcStatus"]}
        value={props.slidesQcStatus}
        onChange={(e: any) =>
          props.onChange("slidesQcStatus", e.target.value || "")
        }
      />
      <TextInput
        id="slidesStainName"
        value={props.slidesStainName}
        label={mapSlidesFilterToLabel["slidesStainName"]}
        onChange={(e: any) =>
          props.onChange("slidesStainName", e.target.value || "")
        }
        onClear={() => props.onChange("slidesStainName", "")}
      />
      <SelectInput
        id="slidesLab"
        label={mapSlidesFilterToLabel["slidesLab"]}
        defaultLabel="All Labs"
        value={props.slidesLab}
        options={mapSlidesFilterToOptions["slidesLab"]}
        onChange={(e: any) => props.onChange("slidesLab", e.target.value || "")}
      />
      <SelectInput
        id="slidesSlideReviewReason"
        label={mapSlidesFilterToLabel["slidesSlideReviewReason"]}
        defaultLabel="All Reasons"
        options={mapSlidesFilterToOptions["slidesSlideReviewReason"]}
        value={props.slidesSlideReviewReason}
        onChange={(e: any) =>
          props.onChange("slidesSlideReviewReason", e.target.value || "")
        }
      />
      <DateRange
        id="slidesScannedDate"
        label={dateInputLabel.slidesScannedDate}
        values={{
          from: {
            id: "slidesScannedDateAfter",
            name: "slides_scanned_after",
            value: props.slidesScannedDateAfter,
          },
          to: {
            id: "slidesScannedDateBefore",
            name: "slides_scanned_before",
            value: props.slidesScannedDateBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
      <DateRange
        id="slidesExpectedUploadDate"
        label={dateInputLabel.slidesExpectedUploadBy}
        values={{
          from: {
            id: "slidesExpectedUploadByAfter",
            name: "slides_expected_upload_by_after",
            value: props.slidesExpectedUploadByAfter,
          },
          to: {
            id: "slidesExpectedUploadByBefore",
            name: "slides_expected_upload_by_before",
            value: props.slidesExpectedUploadByBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
    </>
  );
};

export default SlidesFilters;
